const colors = [
  '#ed553b',
  '#f2b133',
  '#47ab6c',
  '#09d3e6',
  '#23638c',
  '#f52281',
  '#7dc161',
  '#f39d03',
  '#3bafbd',
  '#a51f6a',
  '#bda400',
  '#f08973',
  '#f7d969',
];

export const getColor = (userId) =>
  colors[parseInt(userId, 10) % colors.length];
